import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import EnvelopeIcon from 'components/atoms/icons/envelope';
import { useTranslation } from 'react-i18next';
import { CampaignProgressStatus } from 'infrastructure/enums';

import type { ISmsCampaign } from 'infrastructure/interfaces';

interface IProps {
  data: ISmsCampaign;
  loading: boolean;
  onSend: () => void;
}
const CampaignActionsCol: React.FC<IProps> = ({ data, loading, onSend }) => {
  if (data.status === CampaignProgressStatus.Completed) return <></>;

  const { t } = useTranslation();
  return (
    <BaseButton
      loading={loading}
      icon={<EnvelopeIcon />}
      type="secondary"
      label={t('labels.sendSms')}
      width="140px"
      onClick={onSend}
    />
  );
};

export default CampaignActionsCol;
